import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = { class: "py-1" }
const _hoisted_3 = { class: "py-1" }
const _hoisted_4 = { key: 2 }

import { computed, PropType } from 'vue';
import { useStore } from 'vuex';
import Copy from '@/components/micro/CopyComponent.vue';
import Duration from '@/components/micro/DurationComponent.vue';
import RawRecords from '@/components/micro/RawRecords.vue';
import CnameChainBadge from '@/components/micro/CnameChainBadge.vue';
import DnsRecordsLink from '@/components/micro/DnsRecordsLink.vue';
import { getRecordType } from '@/common/recordTypes';
import { PTR, QueryResult, RecordInfo } from '@/model/Api';

type PtrRecordWithInfo = {
  record: PTR;
} & RecordInfo


export default /*@__PURE__*/_defineComponent({
  __name: 'PtrRecords',
  props: {
  records: {
    type: Object as PropType<QueryResult>,
    required: true,
  },
  domain: {
    type: String,
    required: true,
  },
},
  setup(__props) {

const recordType = getRecordType('PTR');

const props = __props;

const store = useStore();
const showRawOutput = computed(() => store.state.showRawOutput);

const processedRecords = computed(() => {
  const processed: PtrRecordWithInfo[] = props.records.response.answer.filter((item): item is PtrRecordWithInfo => item.record.recordType === recordType.upper);
  return processed;
});

return (_ctx: any,_cache: any) => {
  return (showRawOutput.value)
    ? (_openBlock(), _createBlock(RawRecords, {
        key: 0,
        records: __props.records
      }, null, 8, ["records"]))
    : (processedRecords.value.length !== 0)
      ? (_openBlock(), _createElementBlock("table", _hoisted_1, [
          _cache[0] || (_cache[0] = _createElementVNode("colgroup", null, [
            _createElementVNode("col", { class: "w-2/3" }),
            _createElementVNode("col", { class: "w-1/3" })
          ], -1)),
          _cache[1] || (_cache[1] = _createElementVNode("thead", null, [
            _createElementVNode("tr", { class: "border-b-2 border-gray-200 text-left" }, [
              _createElementVNode("th", {
                scope: "col",
                class: "py-1.5 font-medium"
              }, "Pointer target"),
              _createElementVNode("th", {
                scope: "col",
                class: "py-1.5 font-medium"
              }, "Revalidate in")
            ])
          ], -1)),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(processedRecords.value, (record, index) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: index,
                class: "group"
              }, [
                _createElementVNode("td", _hoisted_2, [
                  _createElementVNode("span", null, [
                    _createVNode(DnsRecordsLink, {
                      domain: record.record.target,
                      class: "text-blue-600 hover:text-blue-800 hover:underline"
                    }, null, 8, ["domain"])
                  ]),
                  _createVNode(CnameChainBadge, {
                    chain: record.cnameChain
                  }, null, 8, ["chain"]),
                  _createVNode(Copy, {
                    content: record.record.target,
                    class: "[visibility:hidden] group-hover:visible"
                  }, null, 8, ["content"])
                ]),
                _createElementVNode("td", _hoisted_3, [
                  _createVNode(Duration, {
                    seconds: record.record.ttl
                  }, null, 8, ["seconds"])
                ])
              ]))
            }), 128))
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, "No " + _toDisplayString(_unref(recordType).plural) + " found.", 1))
}
}

})